import { Pipe, PipeTransform } from '@angular/core';
import { SmsTag } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'smsTagDisplay',
})
export class SmsTagDisplayPipe implements PipeTransform {
  transform(tag: SmsTag): string {
    return smsTagDisplayTransform(tag);
  }
}

export function smsTagDisplayTransform(value: SmsTag) {
  return CoreNiceLabelUtils.smsTag(value);
}
